"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _knotchincWebReactComponentsGraphs = _interopRequireDefault(require("@bit/knotchinc.web-react-components.graphs.knotch-graph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var validator = function validator(_ref) {
  var data = _ref.data;
  return data !== '' && data !== null && data !== undefined;
};

var SummaryTile = function SummaryTile(_ref2) {
  var data = _ref2.data,
      formatter = _ref2.formatter,
      _ref2$message = _ref2.message,
      message = _ref2$message === void 0 ? null : _ref2$message,
      _ref2$pctWidth = _ref2.pctWidth,
      pctWidth = _ref2$pctWidth === void 0 ? 'full' : _ref2$pctWidth,
      isVerticallyAligned = _ref2.isVerticallyAligned;
  return /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponentsGraphs["default"], {
    pctWidth: pctWidth,
    validate: validator,
    data: data
  }, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    fontSize: 3,
    fontWeight: "thin",
    mt: isVerticallyAligned ? 100 : ''
  }, formatter ? formatter(data) : data), message && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    fontSize: 2,
    color: "textLightGrey",
    mt: 10
  }, message));
};

var _default = SummaryTile;
exports["default"] = _default;

//# sourceMappingURL=SummaryTile.jsx.map